
import React, { useEffect, useState } from "react";
import { Link, Routes, Route, useNavigate, NavLink } from "react-router-dom";
import { FiLogOut, FiMenu, FiX } from "react-icons/fi";

import Home from "../screens/user/Home";
import Books from "../screens/user/Books";
import Profile from "../screens/user/Profile";
import UserCalender from "../screens/user/UserCalender";
import Checkout from "../screens/user/Checkout";
import Announcement from "../screens/user/Announcement";
import BookStore from "../screens/user/BookStore";
import logo from "../assets/logo.png";

import "./UserLayout.css";

const UserLayout = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // =========================
  // CHECK LOGIN
  // =========================

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  // =========================
  // LOGOUT
  // =========================

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    setMenuOpen(false);

    navigate("/login", { replace: true });
  };

  // =========================
  // CLOSE MOBILE MENU
  // =========================

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="user-layout">

      {/* =========================
          NAVBAR
      ========================= */}

      <nav className="user-navbar">

        {/* LOGO */}

        <Link
          to="/user"
          className="user-logo-container"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="Ghalib Library"
            className="user-logo-image"
          />

          <div>
            <div className="user-logo">
              Ghalib Library
            </div>

            <div className="user-logo-sub">
              Library Management System
            </div>
          </div>
        </Link>


        {/* =========================
            DESKTOP NAVIGATION
        ========================= */}

        <div className="user-nav-links">

          <NavLink
            to="/user"
            end
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/user/books"
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Books
          </NavLink>

          <NavLink
            to="/user/bookstore"
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Book Store
          </NavLink>

          <NavLink
            to="/user/usercalender"
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Calendar
          </NavLink>

          <NavLink
            to="/user/announcement"
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Announcement
          </NavLink>

          <NavLink
            to="/user/profile"
            className={({ isActive }) =>
              `user-nav-link ${isActive ? "active" : ""}`
            }
          >
            Profile
          </NavLink>

        </div>


        {/* =========================
            DESKTOP LOGOUT
        ========================= */}

        <button
          onClick={handleLogout}
          className="user-logout"
        >
          <FiLogOut style={{ marginRight: "8px" }} />
          Logout
        </button>


        {/* =========================
            MOBILE MENU BUTTON
        ========================= */}

        <button
          className="user-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>


        {/* =========================
            MOBILE MENU
        ========================= */}

        {menuOpen && (
          <div className="user-mobile-menu">

            <NavLink
              to="/user"
              end
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Home
            </NavLink>

            <NavLink
              to="/user/books"
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Books
            </NavLink>

            <NavLink
              to="/user/bookstore"
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Book Store
            </NavLink>

            <NavLink
              to="/user/usercalender"
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Calendar
            </NavLink>

            <NavLink
              to="/user/announcement"
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Announcement
            </NavLink>

            <NavLink
              to="/user/profile"
              onClick={closeMenu}
              className={({ isActive }) =>
                `user-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Profile
            </NavLink>

            <button
              onClick={handleLogout}
              className="user-mobile-logout"
            >
              <FiLogOut style={{ marginRight: "8px" }} />
              Logout
            </button>

          </div>
        )}

      </nav>


      {/* =========================
          PAGE CONTENT
      ========================= */}

      <main className="user-content">

        <Routes>

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="books"
            element={<Books />}
          />

          <Route
            path="bookstore"
            element={<BookStore />}
          />

          <Route
            path="usercalender"
            element={<UserCalender />}
          />

          <Route
            path="announcement"
            element={<Announcement />}
          />

          <Route
            path="profile"
            element={<Profile />}
          />

          <Route
            path="checkout"
            element={<Checkout />}
          />

        </Routes>

      </main>


      {/* =========================
          FOOTER
      ========================= */}

      <footer className="user-footer">

        <div className="user-footer-container">

          {/* ABOUT */}

          <div className="user-footer-section">

            <h3>
              📚 Ghalib Library
            </h3>

            <p>
              Empowering learning through books,
              knowledge, and digital resources.
            </p>

          </div>


          {/* QUICK LINKS */}

          <div className="user-footer-section">

            <h3>
              Quick Links
            </h3>

            <Link
              to="/user"
              className="user-footer-link"
            >
              Home
            </Link>

            <Link
              to="/user/books"
              className="user-footer-link"
            >
              Books
            </Link>

            <Link
              to="/user/bookstore"
              className="user-footer-link"
            >
              Book Store
            </Link>

            <Link
              to="/user/usercalender"
              className="user-footer-link"
            >
              Calendar
            </Link>

            <Link
              to="/user/profile"
              className="user-footer-link"
            >
              Profile
            </Link>

          </div>


          {/* CONTACT */}

          <div className="user-footer-section">
     <h3>
              Contact
            </h3>

            <p>
              📍{" "}
              <a
                href="https://maps.app.goo.gl/PQHPvX3exzVU9xiX6"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Ghalib Library Location
              </a>
            </p>

            <p>
              📞 (021) 33517270
            </p>

            <p>
              📧 idaraeyyadgareghalib@gmail.com
            </p>

            <p>
              🕘 Mon - Fri | 3:00PM-7:30PM
            </p>
          </div>

        </div>


        <hr className="user-footer-line" />

        <p className="user-copyright">
          © {new Date().getFullYear()} Ghalib Library.
          All Rights Reserved.
        </p>

      </footer>

    </div>
  );
};

export default UserLayout;